<template>
  <div class="loading">
    <div class="loading-text h1 text-white">
        {{text}} <br />
      <font-awesome-icon :icon="['fad', 'spinner-third']" spin size="lg" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'loading',
    props: {
      text: {default: 'Guardando'}
    }
  };
</script>
